// state.js
import { ref } from 'vue';

export const actuallRoute = ref('');

// Funzione per aggiornare la route
export const setActuallRoute = (route) => {
  actuallRoute.value = route;
};
